<template>
    <table class="table table-responsive d-sm-table table-bordered tabs-elev-table mb-0 text-sm">
        <thead class="bg-primary-lighter text-white" ref="header">
            <tr>
                <th scope="col" style="min-width: 80px;">{{ $t('Dato') }}</th>
                <th scope="col" style="min-width: 150px;">{{ $t('Produkt') }}</th>
                <th scope="col" v-if="isCompanyAccount">{{ $t('Elev') }}</th>
                <th scope="col" class="d-none d-sm-table-cell">{{ $t('Ant.') }}</th>
                <th scope="col" :title="$t('Betaling')"><span class="d-block d-sm-none">{{ $t('Bet.') }}</span><span class="d-none d-sm-block">{{ $t('Betaling') }}</span></th>
                <th scope="col"><span class="d-block d-sm-none">{{ $t('sale-short') }}</span><span class="d-none d-sm-block">{{ $t('Salg') }}</span></th>
            </tr>
        </thead>
        <tbody>
            <Sale v-for="sale in sales" :sale_index="sale.sale_id" :key="sale.sale_id" :sale_prop="sale"></Sale>
        </tbody>
    </table>
</template>

<script setup>
    import { computed, ref, onMounted } from 'vue'
    import Store from '../../state/accountStore'
    import Sale from './Sale'


    const header = ref(null)

    // Computed
    const sales = computed(() => Store.getSales())
    const isCompanyAccount = computed(() => Store.isCompanyAccount())

    onMounted(() => {
        if (header.value) {
            header.value.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    })
</script>
